export const dollarsToCents = (dollars: string): number => {
  const dollarsFloat = parseFloat(dollars);
  return Math.round(dollarsFloat * 100);
};

export const centsToDollars = (cents: number): string => {
  const dollars = cents / 100;
  if (dollars % 1 === 0) return dollars.toString();
  return dollars.toFixed(2);
};

